exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Quiz__Quiz--1YgKh{\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-grow: 1;\r\n    width: 100%;\r\n    padding-top: 100px;\r\n    background: linear-gradient(90deg, #5041b2 0%, #7969e6 100%)\r\n}\r\n\r\n.Quiz__Quiz--1YgKh h1{\r\n    color:#fff;\r\n    margin-left: 10px;\r\n}\r\n\r\n.Quiz__QuizWrapper--3xC_e{\r\n    width: 600px;\r\n}", ""]);

// exports
exports.locals = {
	"Quiz": "Quiz__Quiz--1YgKh",
	"QuizWrapper": "Quiz__QuizWrapper--3xC_e"
};